// extracted by mini-css-extract-plugin
var _1 = "QuizTemplateStyles-module__action-wrapper___tDQuW";
var _2 = "QuizTemplateStyles-module__action-wrapper___tDQuW";
var _3 = "QuizTemplateStyles-module__cancel-btn___K0x1h";
var _4 = "QuizTemplateStyles-module__cancel-btn___K0x1h";
var _5 = "QuizTemplateStyles-module__description___fZdqE";
var _6 = "QuizTemplateStyles-module__radio___GLbQw";
var _7 = "QuizTemplateStyles-module__root___IUT6Z";
var _8 = "QuizTemplateStyles-module__title___PW5AI";
export { _1 as "action-wrapper", _2 as "actionWrapper", _3 as "cancel-btn", _4 as "cancelBtn", _5 as "description", _6 as "radio", _7 as "root", _8 as "title" }
